import { render, staticRenderFns } from "./AliasDetails.vue?vue&type=template&id=ca1101ac&"
import script from "./AliasDetails.vue?vue&type=script&lang=js&"
export * from "./AliasDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports